export enum PurchasingConfigurationTypeEnum {
  authorisationLevels = 'Authorisation Levels',
  replyToEmail = 'Reply To Email'
}
